<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="goodsId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品编号')}}<template slot="title">{{$t('商品编号')}}</template>
          </a-tooltip>
        </span>
        <a-button type="dashed" @click="openProdSelect" danger>
          <span style="color: dodgerblue"> {{this.getGoodsName()}}</span>
        </a-button>
      </a-form-model-item>
      <a-form-model-item prop="skuId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('SKU编号')}}<template slot="title">SKU编号 ,可不选</template>
          </a-tooltip>
        </span>
        <a-select :placeholder="$t('请选择')+'SKU'"  style="width: 100%" v-model="form.skuId" allowClear>
          <a-select-option v-for="(item, index) in goodsSkuList" :value="item.id" :key="index">
            {{ item.skuName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="totalStock" >
        <span slot="label" >
          <a-tooltip>
            扣减总量<template slot="title">扣减总量</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.totalStock" oninput="value=value.replace(/[^\d]/g,'')" placeholder="请输入扣减总量" />
      </a-form-model-item>
      <!--      <a-form-model-item prop="intervalTime" >
              <span slot="label" >
                <a-tooltip>
                  {{$t('商品自动扣减库存脚本.时间间隔')}}<template slot="title">{{$t('商品自动扣减库存脚本.时间间隔')}}</template>
                </a-tooltip>
              </span>
              <a-input v-model="form.intervalTime"  placeholder="请输入$t('商品自动扣减库存脚本.时间间隔')" />
            </a-form-model-item>-->
      <a-form-model-item prop="limitStock" >
        <span slot="label" >
          <a-tooltip>
            单次扣减上限<template slot="title">单次扣减上限</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.limitStock" oninput="value=value.replace(/[^\d]/g,'')"  placeholder="请输入单次扣减上限" />
      </a-form-model-item>
      <a-form-model-item prop="highStock" >
        <span slot="label" >
          <a-tooltip>
            高频数字<template slot="title">高频数字,逗号分割</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.highStock"  placeholder="请输入高频数字" />
      </a-form-model-item>
      <a-form-model-item prop="startTime" >
        <span slot="label" >
          <a-tooltip>
            开始时间<template slot="title">开始时间</template>
          </a-tooltip>
        </span>
        <a-date-picker style="width: 100%" v-model="form.startTime" valueFormat='YYYY-MM-DD HH:mm:ss' show-time allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="endTime" >
        <span slot="label" >
          <a-tooltip>
            结束时间<template slot="title">结束时间</template>
          </a-tooltip>
        </span>
        <a-date-picker style="width: 100%" v-model="form.endTime" valueFormat='YYYY-MM-DD HH:mm:ss' show-time allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="deductedStock" >
        <span slot="label" >
          <a-tooltip>
            已扣减量<template slot="title">已扣减量</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.deductedStock"  disabled placeholder="请输入已扣减总量" />
      </a-form-model-item>
      <a-form-model-item prop="status" >
        <span slot="label" >
          <a-tooltip>
            是否启用<template slot="title">是否启用</template>
          </a-tooltip>
        </span>
        <a-radio-group v-model="form.status" button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
    <radio-goods-select-form ref="RadioGoodsSelectForm" @goodsSelect="indexGoodsModalSelect"></radio-goods-select-form>
  </a-drawer>
</template>

<script>
import { getStockScript, addStockScript, updateStockScript } from '@/api/goods/stockScript'
import { getGoodsSkuList } from '@/api/goods/goods'
import {mapGetters} from 'vuex'
import RadioGoodsSelectForm from '@/views/goods/goods/modules/RadioSelectForm'
import CustomDictTag from "@/components/DictCustomTag";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
    RadioGoodsSelectForm
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      goodsSkuList: [],
      // 表单参数
      form: {
        id: null,
        goodsId: null,
        totalStock: null,
        intervalTime: null,
        limitStock: null,
        startTime: null,
        endTime: null,
        status: true,
        createTime: null,
        localeFieldMap:{},
        remark: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        goodsId: [
          { required: true, message: this.$t('商品编号')+this.$t('不能为空'), trigger: 'blur' }
        ],
        totalStock: [
          { required: true, message: '扣减总量不能为空', trigger: 'blur' }
        ],
        limitStock: [
          { required: true, message: '单次扣减上限不能为空', trigger: 'blur' }
        ],
        startTime: [
          { required: true, message: '开始时间不能为空', trigger: 'change' }
        ],
        endTime: [
          { required: true, message: '结束时间不能为空', trigger: 'change' }
        ],
        status: [
          { required: true, message: '状态不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        goodsId: null,
        type: null,
        totalStock: null,
        intervalTime: null,
        limitStock: null,
        startTime: null,
        endTime: null,
        status: true,
        createTime: null,
        localeFieldMap:{},
        remark: null,
      }
      this.goodsSkuList = []

    },
    indexGoodsModalSelect(records) {
      this.form.goodsId = records[0].id
      this.form.goodsName = records[0].goodsName
      //清空skuId
      this.form.skuId = null
      //查询sku
      this.getGoodsSkuList(this.form.goodsId)
    },
    getGoodsSkuList(goodsId) {
      getGoodsSkuList({"id": goodsId}).then(response => {
        if (response.code === '20001') {
          this.goodsSkuList = response.data;
        }
      })
    },
    openProdSelect() {
      this.$refs.RadioGoodsSelectForm.openGoods(undefined, [20],[this.form.goodsId]);
    },
    getGoodsName() {
      if (this.form.goodsId) {
        return this.form.goodsName;
      } else {
        return this.$t('选择商品')
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getStockScript({"id":id}).then(response => {
        this.form = response.data
        this.getGoodsSkuList(response.data.goodsId)
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateStockScript(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(
                  message,
                  3
                )
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addStockScript(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(
                  message,
                  3
                );
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
